import { StyledComponentProps } from 'styled-components';
import { Wrapper, Select as SelectEl } from './styles';

interface SelectProps extends StyledComponentProps<'select', never, {}, never> {
	// If you want to limit the width of the select.
	maxWidth?: number;

	// if true, component will expand to fit width its container, even if its items are not wide enough to cause that to happen.
	fullWidth?: boolean; // Default: false
}

export default function Select({ fullWidth = false, maxWidth, ...props }: SelectProps) {
	return (
		<Wrapper fullWidth={fullWidth} maxWidth={maxWidth}>
			<SelectEl {...props} />
		</Wrapper>
	);
}
